import { Component, ElementRef, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonUploadImageService } from 'src/app/services/common-upload-image.service';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { ToastService } from 'src/app/services/toast.service';
import Croppie from 'croppie';
import { imageurl } from 'src/app/constant/constant';

@Component({
    selector: 'app-uploadpartytoken',
    templateUrl: './uploadpartytoken.component.html',
    styleUrls: ['./uploadpartytoken.component.scss'],
    standalone: false
})
export class UploadpartytokenComponent implements OnInit {
  @Input() playerUpdate: any;
  @Input() gameDetailUpdate: any;
  @Input() masterUpdate: any;
  
  tokens: any[] = []; // List of available tokens fetched from the server
  selectedToken: any = null; // Currently selected token
  selectedImage: any; // Temporary storage for the image being cropped
  user_id: string;
  selectedTokenBase64: string;
  image_url: string = imageurl;
  
  @ViewChild('croppieElement') croppieElement: ElementRef;
  croppieInstance: Croppie;

  constructor(
    public activeModal: NgbActiveModal,
    private commonImageUploadService: CommonUploadImageService,
    private currentUserService: CurrentUserService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
 // Fetch tokens when component initializes
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = data.id;
        this.fetchTokens();
      }
    
          this.cdr.detectChanges();});
  }

  /** Fetch the list of available tokens from the server */
  fetchTokens(): void {
    this.commonImageUploadService.getTokens(parseInt(this.user_id)).subscribe((tokens: any) => {
      if(tokens?.party_tokens.length > 0) {
      this.tokens = tokens.party_tokens;
        this.cdr.detectChanges();
      }
      // Assuming tokens are returned as { id: number, image: string }[]
    });
  }

  /** Select a token from the list */
  selectToken(token: any): void {
    this.selectedToken = token
    
    this.urlToBase64(this.image_url + token)
    .then((base64String) => {
      this.selectedTokenBase64 = base64String;
      // Use the base64 string as needed
    })
    .catch((error) => {
      console.error('Error converting URL to base64:', error);
    });
  }

  urlToBase64(url: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result as string);};
        reader.onerror = function (error) {
          reject(error);
        };
        reader.readAsDataURL(xhr.response);};
      xhr.onerror = function (error) {
        reject(error);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
    });
  }


  /** Handle file selection, crop automatically, and upload */handleFileInput(event: any): void {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.selectedImage = reader.result as string;
      
      if (!this.croppieInstance) {
        this.croppieInstance = new Croppie(this.croppieElement.nativeElement, {
          viewport: { width: 150, height: 150, type: 'circle' },
          boundary: { width: 150, height: 150 },
          showZoomer: false,
          enableOrientation: true,
        });
      }

      this.croppieInstance.bind({ url: this.selectedImage }).then(() => {
        // Wait a short moment before getting the result
        setTimeout(() => {
          this.croppieInstance?.result('base64').then((croppedImage) => {
            
            if (croppedImage) {
              this.uploadCroppedImage(croppedImage);
            } else {
              console.error('Cropping failed!');
            }
          }).catch(err => console.error('Croppie result error:', err));
        }, 0); // Small delay to ensure image is fully loaded
      }).catch(err => console.error('Croppie bind error:', err));
    
          this.cdr.detectChanges();};
    reader.readAsDataURL(file);
  }
}


  /** Upload the cropped image to the server and refresh the list */
  uploadCroppedImage(croppedImage: string): void {
    this.commonImageUploadService.uploadToken(parseInt(this.user_id),{images:[croppedImage]}).subscribe((res) => {
      if (res) {
        this.toastService.showSuccess('Party token uploaded.', 'success');
        this.fetchTokens(); // Refresh the token list
        // Reset Croppie instance to free memory (optional)
        if (this.croppieInstance) {
          this.croppieInstance.destroy();
          this.croppieInstance = null;
        }
      }
    
          this.cdr.detectChanges();}, (error) => {
    
          this.cdr.detectChanges();});
  }

  /** Confirm selection and associate the selected token with the entity */
  confirmSelection(): void {
    if(this.selectedTokenBase64){
      if(this.masterUpdate){
      this.commonImageUploadService.gameMasterPartyTokenUpload({gamemasterid:this.masterUpdate,partytoken  :this.selectedToken}).subscribe((res) => {
        if (res) {
          this.toastService.showSuccess('Party token uploaded.', 'success');
          this.activeModal.close(this.selectedTokenBase64);
        }
      
          this.cdr.detectChanges();},(error) => {
        this.toastService.showSuccess(error.error.error || 'Something went Wrong !!!', 'danger');
      
          this.cdr.detectChanges();})}
      else{
        this.activeModal.close(this.selectedToken);
      }
    }
    else{
      this.toastService.showSuccess('Choose a token first.', 'danger');
    }
  }

  /** Close the modal */
  closemodel(): void {
    this.activeModal.close();
  }
}
